//for local website
// const imageBaseUrl = 'http://dpg-backend.test';
//for live website
const imageBaseUrl = 'https://admin.dubaipetsgroomer.com';

export function getImageUrl(imagePath) {
  return imagePath ? `${imageBaseUrl}/${imagePath}` : '@/assets/images/default-icon.svg';
}

export function getBookingDownloadUrl(bookingId) {
  if (typeof window !== 'undefined' && window.location.port === '8080') {
    return `${window.location.origin}/api/download-booking/${bookingId}`;
  }

  return `${imageBaseUrl}/api/download-booking/${bookingId}`;
}
